var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45.5,
    r: 44.5,
    stroke: "#A855F7",
    strokeOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45.5,
    r: 40,
    fill: "#A855F7",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3107 54.5233C28.6855 55.1482 28.3342 55.996 28.334 56.8799V60.4999C28.334 60.942 28.5096 61.3659 28.8221 61.6785C29.1347 61.991 29.5586 62.1666 30.0007 62.1666H35.0007C35.4427 62.1666 35.8666 61.991 36.1792 61.6785C36.4917 61.3659 36.6673 60.942 36.6673 60.4999V58.8333C36.6673 58.3912 36.8429 57.9673 37.1555 57.6548C37.468 57.3422 37.892 57.1666 38.334 57.1666H40.0007C40.4427 57.1666 40.8666 56.991 41.1792 56.6785C41.4917 56.3659 41.6673 55.942 41.6673 55.4999V53.8333C41.6673 53.3912 41.8429 52.9673 42.1555 52.6548C42.468 52.3422 42.892 52.1666 43.334 52.1666H43.6207C44.5046 52.1664 45.3523 51.8151 45.9773 51.1899L47.334 49.8333C49.6504 50.6402 52.172 50.6371 54.4865 49.8245C56.8009 49.012 58.771 47.438 60.0746 45.3601C61.3782 43.2823 61.938 40.8236 61.6625 38.3862C61.387 35.9488 60.2925 33.677 58.558 31.9426C56.8236 30.2081 54.5518 29.1136 52.1144 28.8381C49.677 28.5626 47.2183 29.1224 45.1404 30.426C43.0626 31.7296 41.4886 33.6997 40.6761 36.0141C39.8635 38.3286 39.8604 40.8502 40.6673 43.1666L29.3107 54.5233Z",
    stroke: "#A855F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4993 38.8332C52.9596 38.8332 53.3327 38.4601 53.3327 37.9998C53.3327 37.5396 52.9596 37.1665 52.4993 37.1665C52.0391 37.1665 51.666 37.5396 51.666 37.9998C51.666 38.4601 52.0391 38.8332 52.4993 38.8332Z",
    fill: "#A855F7",
    stroke: "#A855F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup21);
export default __webpack_public_path__ + "static/media/Group 21.470ac7aa4958cb7c6c78a893f267f206.svg";
export { ForwardRef as ReactComponent };